/*!
 * This file was created by jetgraph Inc.
 * Copyright © 2025 jetgraph Inc. All rights reserved.
 * Unauthorized copying or redistribution is prohibited.
 */



$(function(){

animationFunc();


}); //ready








/* 変化前:変化後のClass名登録 後半はanimate.css用*/
var classArray = {
"zoom-in":"zoomIn",
"zoom-in-inner":"zoomInInner",
"zoom-in-light":"zoomInLight",
"zoom-in-light-inner":"zoomInLightInner",
"zoom-up":"zoomUp",
"zoom-up-inner":"zoomUpInner",
"zoom-up-light":"zoomUpLight",
"zoom-up-light-inner":"zoomUpLightInner",
"slide-in-left":"slideInLeft",
"slide-in-right":"slideInRight",
"slide-in-left-inner":"slideInLeftInner",
"slide-in-left-blur":"slideInLeftBlur",
"slide-out-left":"slideOutLeft",
"slide-out-left-inner":"slideOutLeftInner",
"slide-out-right":"slideOutRight",
"slide-out-right-inner":"slideOutRightInner",
"slide-in-right":"slideInRight",
"slide-in-right-inner":"slideInRightInner",
"slide-in-top":"slideInTop",
"slide-in-top-p":"slideInTopP",
"slide-in-top-py":"slideInTopPy",
"slide-in-top-inner":"slideInTopInner",
"slide-in-bottom":"slideInBottom",
"slide-in-bottom-inner":"slideInBottomInner",
"fade-in":"fadeIn",
"fade-in-inner":"fadeInInner",
"fade-out":"fadeOut",
"fade-out-inner":"fadeOutInner",
"rotate-right-10deg":"rotateRight10deg",
"rotate-right-20deg":"rotateRight20deg",
"rotate-right-60deg":"rotateRight60deg",
};



function animationFunc(){

/* inviewへの設定（上の配列から） */
var keyArray = Object.keys(classArray);
for (var i=0; i < keyArray.length; i++){
var keys = keyArray[i];
var data = classArray[keys];
addClassFunc(keys,data);
}//for
function addClassFunc(keys,data){
$("." + keys).on('inview', function(event, isInView) {
$(this).addClass("animated");
if (isInView) {
$(this).addClass(data);
//$(this).removeClass(keys);
} else {
/*$(this).removeClass(data);消すと戻ったら再度動く*/ 
}//else
});//on('inview', function
}//addClassFunc



}//animationFunc











$(window).on("load",function(){



});//load
